import React from 'react'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { GlobalStudentTask } from '../StudentManagement'

// Parent view for a single student's tasks.
// Assumes that the authenticated parent user object contains a `studentId` field
// pointing to the related student's id in `studentinfo` / taskmanageview.to.
// If this field is named differently in your profiles schema, adjust below.
const ParentTask = () => {
	const { user } = useAuth()

	// For now we assume a single linked student per parent.
	// If there is no linked student, show a friendly message.
	const studentId = user?.studentId

	if (!studentId) {
		return (
			<div className="container-fluid">
				<div className="row">
					<div className="col-12">
						<div className="card">
							<div className="card-body">
								<h5 className="card-title mb-3">Student Tasks</h5>
								<p className="mb-0">No active student is linked to this parent account.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	return (
		<div className="container-fluid">
			{/* Parent view: only show the student's global task/agenda summary here.
				Detaylı \"Agenda Management\" tablosu parent için ayrı bir Agenda sayfasında gösterilecek. */}
			<GlobalStudentTask studentId={studentId} type={226} isStudent={true} />
		</div>
	)
}

export { ParentTask }


